export default "__VITE_ASSET__D4AX8MwC__"